<router-outlet />

<app-confirmation />
<app-http-loading />

@if (isBrowserContext) {
  <app-toast />
}

@if (isBrowserContext) {
  <app-cookie-banner />
}
